const credibilityCheckMessages = {
  'credibilityCheckResult.description.msg.ok': '改ざんチェック済み',
  'credibilityCheckResult.description.msg.ng':
    '画像および撮影日時が改ざんもしくは編集されています',
  'credibilityCheckResult.description.msg.ng_image':
    '画像が改ざんもしくは編集されています',
  'credibilityCheckResult.description.msg.ng_date':
    '撮影日時が改ざんもしくは編集されています',
  'credibilityCheckResult.description.msg.nt': '改ざんチェック対象外',
};

export default credibilityCheckMessages;
